import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SecurityTipsDialogComponent } from 'app/modules/shared/containers/security-tips-dialog/security-tips-dialog.component';

/**
 * Opens the security tips (BSI TR-03161-2 O.Plat_8): the measures a user can take to use ADELE safely. They are
 * always at hand in the user menu and linked from the security notice that is shown after the first sign-in.
 */
@Injectable({ providedIn: 'root' })
export class SecurityTipsService {
    private _dialog = inject(MatDialog);
    private _ref: MatDialogRef<SecurityTipsDialogComponent> | null = null;

    open(): void {
        if (this._ref) {
            return;
        }
        this._ref = this._dialog.open(SecurityTipsDialogComponent, {
            width: '600px',
            maxWidth: '95vw',
            autoFocus: false,
        });
        this._ref.afterClosed().subscribe(() => (this._ref = null));
    }
}
